import React from 'react';
import { experienceData } from '../../data';
import { ExperienceCard, ExperienceSection, Organization, OrganizationDetails, OrganizationTitle, Schedule } from '../styled/Experience.styled';

const Experience = () => {
    return (
        <>
            <ExperienceSection>
                <h4>Experience</h4>
                <ExperienceCard>
                    {experienceData.map((ele, index) => (
                        <Organization key={index}>
                            <Schedule md={2}>
                                <span>{ele.from} - {ele.to}</span>
                            </Schedule>
                            <OrganizationDetails md={10}>
                                <OrganizationTitle>
                                    <h3>{ele.head} - <span>{ele.bold}</span></h3>
                                    <span>{ele.tag}</span>
                                </OrganizationTitle>
                                <p>{ele.body}</p>
                            </OrganizationDetails>
                        </Organization>
                    ))}



                </ExperienceCard>
            </ExperienceSection>
        </>
    );
};

export default Experience;